import { BaseModel } from "./BaseModel";
import { ColumnHeaders, TabNames } from '../modules/Constants';

export class MEProcessModel extends BaseModel {
    //supplementalFormatting(formatting) {

    //    formatting.columns[4].width = 300;
    //    formatting.columns[5].width = 300;
    //    formatting.columns[6].width = 150;
    //    formatting.columns[19].width = 150;

    //    return formatting;
    //}

    constructor() {
        super();
        this.TabName = TabNames.ME_PROCESS;
        this.TabIndex = 7;
        this.DataProcessor = new MEProcessProcessor();
    }
}

export class MEProcessProcessor {

    process(data) {

        // -- Define Variabbles
        let records = [];
        let headers = [];

        let snapshots = data.snapshots;

        // -- Set Records
        records = this.setRecords(snapshots);
        
        // -- Set Headers
        headers = this.configureHeader();

        // -- Get Rows
        let result = {
            headers: headers,
            display: this.getDisplay(headers, records),
            numerics: this.getNumerics(headers)
        };
        return result;
    }

    setRecords(snapshots) {
        let records = [];

        snapshots.forEach(snapshot => {
            let mfgs = snapshot.Manufacturing;

            mfgs?.forEach(mfg => {
                let ops = mfg.Operations;

                ops?.forEach(op => {
                    records.push(new MEProcessRowModel(snapshot, mfg, op));
                })
            })
        })

        return records;
    }

    configureHeader() {
        let header = [
            ColumnHeaders.OPTION_NAME,
            ColumnHeaders.PLANT,
            ColumnHeaders.MFG_PRO_NAME,
            ColumnHeaders.PEAK_ANNUAL_VOLUME,
            ColumnHeaders.RUN_TIME_PER_THREE_SHIFTS,
            ColumnHeaders.WORKING_DAYS_PER_YEAR,
            ColumnHeaders.PROCESS_TYPE,
            ColumnHeaders.OPERATION_NUMBER,
            ColumnHeaders.OPERATION_DESCRIPTION,
            ColumnHeaders.LEAD_TIME_WEEKS,
            ColumnHeaders.MFG_COMMENTS,
            ColumnHeaders.CREW_SIZE,
            ColumnHeaders.CYCLE_TIME,
            ColumnHeaders.EFFICIENCY,
            ColumnHeaders.LABOR_IN_OPERATION,
            ColumnHeaders.LINKED_OPERATION,
            ColumnHeaders.EXISITING_MACHINES,
            ColumnHeaders.NEW_MACHINES,
            ColumnHeaders.CALCULATED_STD_HOURS,
            ColumnHeaders.MISC_PIECE_COST
        ];

        return header;
    }

    getDisplay(headers, records) {
        let display = [];

        display.push(headers);

        records.forEach(record => {
            let row = [
                record.OptionName,
                record.Plant,
                record.MfgProName,
                record.PeakAnnualVolume,
                record.RunTimePerThreeShifts,
                record.WorkingDaysPerYear,
                record.ProcessType,
                record.OperationNumber,
                record.OperationDescription,
                record.LeadTimeWeeks,
                record.MfgComments,
                record.CrewSize,
                record.CycleTime,
                record.Efficiency,
                record.LaborInOperation,
                record.LinkedOperation,
                record.ExistingMachines,
                record.NewMachines,
                record.CalculatedStdHours,
                record.SerializedMiscPieceCost
            ]

            display.push(row);
        })

        return display;
    }

    getNumerics(headers) {
        let numeric = [];

        //set number formatting
        let cycleTime = headers.findIndex((x) => x === ColumnHeaders.CYCLE_TIME);
        let stdHrs = headers.findIndex((x) => x === ColumnHeaders.CALCULATED_STD_HOURS);
        let pieceCost = headers.findIndex((x) => x === ColumnHeaders.MISC_PIECE_COST);
        

        numeric.push({ start: cycleTime, end: cycleTime });
        numeric.push({ start: stdHrs, end: stdHrs, format: '#,##0.00000' });
        numeric.push({ start: pieceCost, end: pieceCost });

        return numeric;
    }

}

export class MEProcessRowModel {
    OptionName = "";
    Plant = "";
    MfgProName = "";
    PeakAnnualVolume = "";
    RunTimePerThreeShifts = "";
    WorkingDaysPerYear = "";
    ProcessType = "";
    OperationNumber = "";
    OperationDescription = "";
    LeadTimeWeeks = "";
    MfgComments = "";
    CrewSize = "";
    CycleTime = "";
    Efficiency = "";
    LaborInOperation = "";
    LinkedOperation = "";
    ExistingMachines = "";
    NewMachines = "";
    CalculatedStdHours = "";
    SerializedMiscPieceCost = "";

    constructor(snapshot, mfg, operation) {
        this.OptionName = snapshot?.GroupName;
        this.Plant = mfg?.Plant?.Value?.Fields[0]?.Number?.Fields[0];
        this.MfgProName = mfg?.Name?.Value?.Fields[0];
        this.PeakAnnualVolume = mfg?.PeakAnnualVolume?.Value?.Fields[0];
        this.RunTimePerThreeShifts = mfg?.RunTimePerThreeShifts?.Value?.Fields[0];
        this.WorkingDaysPerYear = mfg?.WorkingDaysPerYear?.Value?.Fields[0];
        this.ProcessType = operation?.ProcessType?.Value?.Fields[0]?.Fields[0];
        this.OperationNumber = operation?.OperationNumber?.Fields[0];
        this.OperationDescription = operation?.Description?.Value?.Fields[0];
        this.LeadTimeWeeks = operation?.LeadTime?.Value?.Fields[0];
        this.MfgComments = operation?.MEComments?.Value?.Fields[0];
        this.CrewSize = operation?.CrewSize?.Value?.Fields[0];
        this.CycleTime = operation?.CycleTime?.Value?.Fields[0];
        this.Efficiency = operation?.Efficiency?.Value?.Fields[0];
        this.LaborInOperation = operation?.LaborInOperation?.Value?.Fields[0];
        this.LinkedOperation = operation?.LinkedId?.Value?.Fields[0];
        this.ExistingMachines = operation?.ExistingMachines?.Value?.Fields[0];
        this.NewMachines = operation?.NewMachines?.Value?.Fields[0];
        this.CalculatedStdHours = operation?.StandardHoursValue;
        this.SerializedMiscPieceCost = operation?.MiscellaneousManufacturingPieceCost?.Value?.Fields[0]?.Values[0]?.Value;
    }
}